<p>This is the administration interface for
  <span>Dangl.<strong>AVACloud</strong></span>.</p>
  @if (!isAuthenticated()) {
    <button mat-button routerLink="/login">Login</button>
  }
